



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import appStore from '@/core/app/app.store';
import { BreadcrumbItem } from '@/types/contentServerContract';

@Component
export default class BreadcrumbParentCategory extends Vue {
    // :class="{'pt-10 bg-white': isProductDetailsPage, 'pt-4 md:pt-2 lg:pt-0 pb-15': isProductListPage}"
    get breadcrumbs(): BreadcrumbItem[] {
        const crumbs = appStore?.breadcrumbPrettified ? [...appStore.breadcrumbPrettified] : [];
        return crumbs;
    }

    get parentPage(): null | BreadcrumbItem {
        if (this.breadcrumbs.length > 2) {
            const parentPage = (this.breadcrumbs.length >= 2 && this.breadcrumbs[this.breadcrumbs.length - 2]);
            return parentPage || null;
        }
        return null;
    }
}
